import request from '../../helpers/request';

import { QueryKeys } from '../../config/constants/react-query';
import { BASE_URL } from '../../config/constants/contants';

import { TSupportedLanguages } from '../../types/TSupportedLanguages';
import { TGetLibraryNewsResponse } from '../../types/TGetLibraryNewsResponse';

const useGetLibraryNews = (
  offset: number,
  language: TSupportedLanguages,
  page: number,
) => {
  const { data, isLoading, error, refetch } = request<TGetLibraryNewsResponse>(
    `${BASE_URL}/api/v1/library?offset=${offset}&language=${language}&page=${page}`,
    QueryKeys.Library,
    true,
    page,
  );

  return { data, isLoading, error, refetch };
};

export default useGetLibraryNews;
